import * as cryptojs from 'crypto-js';
import { FILEKEY } from './config';

export function encrypt(target: string): string {
  const encrypted = cryptojs.AES.encrypt(target, FILEKEY);

  return encrypted.toString();
}

export function decrypt(target: string): string {
  const bytes = cryptojs.AES.decrypt(target, FILEKEY);
  const result = bytes.toString(cryptojs.enc.Utf8);
  return result;
}
